import Vue from "vue";
import VueRouter from "vue-router";
import OurStory from "../views/OurStory.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "OurStory",
    component: OurStory
  },
  {
    path: "/ourcelebration",
    name: "ourcelebration",
    component: () =>
      import(
        /* webpackChunkName: "ourcelebration" */ "../views/OurCelebration.vue"
      )
  },
  {
    path: "/gallery",
    name: "gallery",
    component: () =>
      import(/* webpackChunkName: "gallery" */ "../views/Gallery.vue")
  },
  {
    path: "/travel",
    name: "travel",
    component: () =>
      import(/* webpackChunkName: "travel" */ "../views/Travel.vue")
  },
  {
    path: "/accomodation",
    name: "accomodation",
    component: () =>
      import(/* webpackChunkName: "accomodation" */ "../views/Accomodation.vue")
  },
  {
    path: "/contact",
    name: "contact",
    props(route) {
      return route.query || {};
    },
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue")
  },
  {
    path: "/register",
    name: "register",
    props(route) {
      return route.query || {};
    },
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue")
  },
  {
    path: "/registry",
    name: "registry",
    props(route) {
      return route.query || {};
    },
    component: () =>
      import(/* webpackChunkName: "registry" */ "../views/Registry.vue")
  },
  {
    path: "/rsvp",
    name: "rsvp",
    props(route) {
      return route.query || {};
    },
    component: () => import(/* webpackChunkName: "rsvp" */ "../views/Rsvp.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
